module.exports = __webpack_public_path__ + "img/product.28ed78a6.png";